import type { ThemeWithoutTokens } from '../theme.types';

export const filterTokens = (theme: ThemeWithoutTokens) =>
  ({
    filterTextColor: theme.colors.primary.normal,
    filterFontFamily: theme.typography.fontFamily.regular,
    filterFontSize: theme.typography.fontSize.m,
  }) as const;
